import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import GeneralSetting from "./GeneralSetting";
import NotificationSetting from "./NotificaitonSetting";
import SecuritySetting from "./SecuritySetting";
import {
  IGeneralSettings,
  INotificationSettings,
  ISecuritySettings,
} from "../../exports/interfaces";
import { useLocation } from "react-router-dom";

type SettingsProps = {
  generalSettings: IGeneralSettings | null;
  setGeneralSettings: Dispatch<SetStateAction<IGeneralSettings | null>>;
  notificationSettings: INotificationSettings | null;
  setNotificationSettings: Dispatch<
    SetStateAction<INotificationSettings | null>
  >;
  securitySettings: ISecuritySettings | null;
  setSecuritySettings: Dispatch<SetStateAction<ISecuritySettings | null>>;
};

const Settings = ({
  generalSettings,
  setGeneralSettings,
  notificationSettings,
  setNotificationSettings,
  securitySettings,
  setSecuritySettings,
}: SettingsProps) => {
  const location = useLocation();
  const settingTabs = [
    { key: "general", label: "General" },
    { key: "notification", label: "Notification" },
    { key: "security", label: "Security" },
  ];
  const [settingTab, setSettingTab] = useState("general");
  useEffect(() => {
    const tab = location.state?.tab;

    if (tab) {
      setSettingTab(tab);
    }
  }, [location]);

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h3>Settings</h3>
          <small>Manage system-wide preferences and security</small>
        </div>
      </div>
      <ul className="nav nav-tabs mt-2 flex-nowrap overflow-auto text-nowrap">
        {settingTabs.map((tab) => (
          <li className="nav-item" key={tab.key}>
            <button
              className={`nav-link ${settingTab === tab.key ? "active" : ""}`}
              onClick={() => setSettingTab(tab.key)}
            >
              {tab.label}
            </button>
          </li>
        ))}
      </ul>

      {settingTab === "general" && (
        <GeneralSetting
          generalSettings={generalSettings}
          setGeneralSettings={setGeneralSettings}
        />
      )}
      {settingTab === "notification" && (
        <NotificationSetting
          notificationSettings={notificationSettings}
          setNotificationSettings={setNotificationSettings}
        />
      )}
      {settingTab === "security" && (
        <SecuritySetting
          securitySettings={securitySettings}
          setSecuritySettings={setSecuritySettings}
        />
      )}
    </>
  );
};

export default Settings;
